import { memo, useCallback, useMemo } from "react";

import { Button } from "@/components/ui/button/button";

type Props = {
	hasError: boolean;
	isDirty: boolean;
	onClickUpdatePlainSettingAndWidget: () => void;
};

export const SaveButton = memo(({ hasError, isDirty, onClickUpdatePlainSettingAndWidget }: Props) => {
	// エラーが発生しているもしくは変更がない
	const disabled = useMemo(() => hasError || !isDirty, [hasError, isDirty]);

	const handleClick = useCallback(() => {
		onClickUpdatePlainSettingAndWidget();
	}, [onClickUpdatePlainSettingAndWidget]);

	return (
		<Button variant={disabled ? "disabled" : "default"} size="xl" onClick={handleClick}>
			保存
		</Button>
	);
});
